import axios from "axios";

const baseURL = "https://api.rubiconbpe.com";
// const baseURL = "http://localhost:3005";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
